var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHyphen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 38,
    viewBox: "0 0 115 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_164_33667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.1204 28.0467H61.0938V1.6709H65.1204V11.7289H65.4275C66.2124 10.3573 67.8844 9.16162 70.2732 9.16162C74.1975 9.16162 76.791 12.186 76.791 15.9842V28.0467H72.7642V16.9689C72.7642 14.6829 71.0922 13.1004 69.0447 13.1004C66.8608 13.1004 65.1204 14.7885 65.1204 17.0744V28.0467Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3984 36.1367H44.425V25.7271H44.7323C45.4829 26.8524 47.0868 28.5053 50.2604 28.5053C55.0378 28.5053 58.5184 24.3555 58.5184 18.8342C58.5184 13.2777 54.7989 9.16309 49.9874 9.16309C46.9162 9.16309 45.4147 10.8863 44.6981 11.8358H44.391V9.62026H40.3984V36.1367ZM49.4072 24.6017C46.6432 24.6017 44.3568 22.4917 44.3568 18.8342C44.3568 15.7043 46.3019 13.0667 49.339 13.0667C52.1713 13.0667 54.3894 15.3526 54.3894 18.8342C54.3894 22.2455 52.2395 24.6017 49.4072 24.6017Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.084 36.1356H24.6433C27.271 36.1356 29.3525 35.0454 30.3079 32.5133L38.7026 9.61914H34.3347L29.6938 24.0731H29.3867L25.1893 9.61914H20.8555L26.9979 28.047H27.9875L26.9979 30.6142C26.5542 31.7748 25.8718 32.3374 24.6433 32.3374H22.084V36.1356Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.1073 28.5053C91.8269 28.5053 95.1028 26.6062 96.2631 22.773L92.5777 21.8586C91.9292 23.8984 90.0525 24.9534 88.0732 24.9534C85.1385 24.9534 83.1935 22.984 83.1593 19.8893H96.7067V18.7287C96.7067 13.2425 93.3966 9.16309 87.9368 9.16309C83.1252 9.16309 78.9961 13.0667 78.9961 18.8694C78.9961 24.4963 82.6475 28.5053 88.1073 28.5053ZM83.1935 16.8648C83.4323 14.6493 85.3774 12.7854 87.9368 12.7854C90.3936 12.7854 92.4071 14.3679 92.6118 16.8648H83.1935Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.281 28.0482H99.2539V9.62026H103.281V11.7303H103.588C104.373 10.3236 106.011 9.16309 108.399 9.16309C112.324 9.16309 114.815 12.1875 114.815 15.9857V28.0482H110.788V16.9703C110.788 14.6844 109.218 13.1019 107.171 13.1019C104.953 13.1019 103.281 14.8602 103.281 17.1813V28.0482Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.015625 3.43066H4.15321V13.5414H14.689V17.5417H4.15321V28.048H0.015625V17.5417H4.15321V13.5414H0.015625V3.43066Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6895 3.43066H18.8271V28.048H14.6895V3.43066Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_164_33667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114.8,
    height: 36.5273,
    fill: "white",
    transform: "translate(0.0136719 0.641602)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyphen);
export default __webpack_public_path__ + "static/media/hyphen.a22d920c064bbc196cb31bd41cafe36e.svg";
export { ForwardRef as ReactComponent };